module.exports = __webpack_public_path__ + "static/media/bookredux.cc50901b.gif";